var Dimensions = require('react-native').Dimensions;

exports.get = Dimensions.get;

exports._addEventListener = Dimensions.addEventListener;

exports._removeEventListener = Dimensions.removeEventListener;
